import { get } from "lodash";

import { evaluateComparison } from "utils";

export function evaluate(context) {
  return ({ predicates }) => {
    if (!Array.isArray(predicates)) return true;
    if (!context) return false;

    return predicates.every(({ path, value, opr }) => {
      return evaluateComparison(get(context, path), opr, value);
    });
  };
}

export default evaluate;
